<template>
  <div class="p-8 shadow-md mt-8 rounded-app bg-white">
    <div class="md:flex md:justify-between">
      <div class="flex justify-between">
        <div
          class="flex gap-2 items-center"
          v-if="!config_general_single_company"
        >
          <img
            :src="job.company.logo"
            alt="Company logo"
            class="w-12 h-12 rounded-full"
          />
          <div>
            <h3 class="text-lg text-[#212429] my-2">
              {{ job.company.name }}
            </h3>
            <p class="text-sm text-[#58585E]">
              {{ job.company.domain }}
            </p>
          </div>
        </div>
      </div>

<!--      <div v-if="job.internal">-->
<!--        <span class="text-sm text-body">-->
<!--          <Icon name="apartment" class="!text-sm text-primary" />-->
<!--          {{ __("Internal job") }}-->
<!--        </span>-->
<!--      </div>-->
    </div>

    <h3 class="flex items-center gap-1 text-xl text-[#212429] cursor-pointer">
      <Icon
        name="work"
        :is_filled="true"
        class="text-primary"
        v-if="config_general_single_company"
      />
      {{ job.title }}
    </h3>
<!--    <p class="text-sm text-body" v-if="job.city">-->
<!--      <span v-for="(city, index) in job.city" :key="index" class="text-body"-->
<!--        >{{ city.name }}-->
<!--        <span v-if="index !== job.city.length - 1">, </span>-->
<!--      </span>-->
<!--    </p>-->
    <div class="flex items-center gap-8 my-4">
      <div v-if="!config_general_single_company && job.company.isCompanyApproved && job.company.isVettingOn" class="flex items-center gap-2">
        <Icon name="verified_user" class="text-status-active text-sm" />
        <span class="text-body text-sm">
              {{ __('Verified Company') }}
            </span>
      </div>
      <div v-if="job.internal">
        <span class="text-sm text-body">
          <Icon name="apartment" class="!text-sm text-primary" />
          {{ __("Internal job") }}
        </span>
      </div>
      <div
          v-if="job?.vulnerability?.length || job?.disability?.length"
      >
      <span class="text-sm text-body">
        <Icon name="diversity_1" class="!text-sm text-primary" />
        {{ __("We embrace diversity and equal opportunity.") }}
      </span>
      </div>

    </div>

    <JobOverview :job="job" />

    <div :class="reportMisconductOn
            ? 'grid grid-cols-1 sm:grid-cols-2 gap-y-2 text-xs text-body'
            : 'grid grid-cols-2 gap-y-2 text-xs text-body'
    ">
      <div class="flex gap-2">
        <div v-if="job.job_reactivated && job.show_job_reactivated" class="flex items-center gap-2">
          <span>{{ __('Updated') }} {{ job.reactivated_at }}</span>
        </div>
        <div v-else>
          <span>{{ __('Posted') }} {{ job.posted_at }}</span>
        </div>
        <span> {{ job.job_views_count }} {{ __("views") }} </span>
      </div>

      <div class="text-right" v-if="user_type === 'user'">
        <div :class="reportMisconductOn
                  ? 'justify-start sm:justify-end'
                  : 'justify-end'"
            class="flex justify-start sm:justify-end items-center gap-2">
          <ReportButton v-if="reportMisconductOn" :user="user"/>
          <span
            v-if="job.conditions.is_applied"
            class="flex items-center gap-1 text-xs sm:text-sm font-medium text-success"
          >
            <Icon name="beenhere" class="!text-base text-success" />
            <span class="font-medium text-sm">
              {{ __("Already applied") }}
            </span>
          </span>
          <span v-else class="flex items-center gap-1 text-xs sm:text-sm font-medium text-gray-800">
            <Icon name="bookmark" class="text-lg text-gray-800" is-filled />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from "../../../../components/global";
import { __ } from "@/helpers";
import { JobOverview } from "../components";
import {ref} from "vue";
import ReportButton from "../../../../components/other/report-button/report-button.vue";

const props = defineProps({
  job: {
    type: Object,
    required: true,
  },
  user_type: {
    type: String,
    required: true,
  },
  config_general_single_company: {
    type: Number,
    required: true,
  },
  reportMisconductOn: {
    type: Number,
    required: true,
  },
  user: {
    type: Object,
  }
});
const showMisconductModal = ref(false);
</script>
